var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.display)?_c('div',{staticClass:"section text-only",class:{ 'background--gray': _vm.fields.backgroundColor }},[(_vm.fields.content)?_c('rich-text',{attrs:{"document":_vm.fields.content}}):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }